import { Component } from '@angular/core';

@Component({
  selector: 'kt-app-features-details-section',
  standalone: true,
  templateUrl: './features-details-section.component.html',
  styleUrl: './features-details-section.component.scss'
})
export class FeaturesDetailsSectionComponent {

}
